import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { ROUTE_STRINGS, TABLE_CONST } from 'Utils/Constants'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import { DialogModal } from 'Components/UIComponents'
import LayoutContainer from 'Components/LayoutComponent'
import Loader from 'Components/Loader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const marketName = [
  {
    idMarket: 1,
    marketName: 'Robusta',
    marketCode: 'RC'
  },
  {
    idMarket: 2,
    marketName: 'Arabica',
    marketCode: 'KC'
  }
]

const ListVolumnAndIntrestData = ({ setLoading }) => {
  const { t } = useTranslation()
  let rowCount = 8
  let paginationButtons = TABLE_CONST.paginationButtonCount
  const history = useHistory()
  const [searchQuery, setSearchQuery] = useState('')
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [selectedValue, setSelectedValue] = useState({ idMarket: 1, marketName: 'Robusta', marketCode: 'RC' })
  const [totalHistoryData, setTotalHistoryData] = useState([])
  const [showDialog, setShowDialog] = useState({ showModal: false, modalType: '', message: '', onHide: () => {}, onRetry: () => {} })

  if (windowSize < TABLE_CONST.maxWidthTab) {
    rowCount = TABLE_CONST.mobileRowCount
    paginationButtons = TABLE_CONST.mobilePaginationButtonCount
  }

  const handleWindowResize = () => {
    setWindowSize(window.innerWidth)
  }

  useEffect(() => {
    fetchVolumeInterestData(selectedValue?.idMarket)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  const fetchVolumeInterestData = async (marketId) => {
    setLoading(true)
    try {
      const { data } = await apiAdapterCoffeeWeb.getVolumeInterestData({ idMarket: marketId })

      setTotalHistoryData(data.returnLst)
    } catch {
      setLoading(false)
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: t('NO_DATA_FOUND'),
        onRetry: () => fetchVolumeInterestData(marketId),
        onHide: handleDismiss
      })
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value

    fetchVolumeInterestData(value.idMarket)

    setSelectedValue(value)
  }

  const handleSearch = (event) => {
    setSearchQuery(event.target.value)
  }

  const handleClickAddButton = () => {
    history.push({
      pathname: ROUTE_STRINGS.addVolumeAndInterest
    })
  }

  const handleClickEditButton = (rowData) => {
    history.push({
      pathname: ROUTE_STRINGS.editVolumeAndInterest,
      state: { volumeInterestData: rowData }
    })
  }

  const renderActionButtons = (rowData) => (
    <div className="action-buttons-wrapper">
      <Button type="button" icon="pi pi-pencil" className="edit-button" tooltip={t('EDIT')} tooltipOptions={{ position: 'top' }} onClick={() => handleClickEditButton(rowData)} />
    </div>
  )

  const tableColumns = [
    {
      dataField: 'date',
      text: t('DATE')
    },

    {
      dataField: 'marketName',
      text: t('MARKET_NAME')
    },

    {
      dataField: 'totalVolume',
      text: t('VOLUME')
    },

    {
      dataField: 'volumeDifference',
      text: t('VOLUME_DIFFERENCE')
    },

    {
      dataField: 'totalOpenInterest',
      text: t('OPEN_INTEREST')
    },
    {
      dataField: 'openInterestDifference',
      text: t('INTEREST_DIFFERENCE')
    },
    {
      text: t('ACTIONS'),
      className: 'action-column',
      body: renderActionButtons
    }
  ]

  const handleDismiss = () => {
    setShowDialog({ ...showDialog, showModal: false })
  }

  const filteredTableData = totalHistoryData?.filter((item) => item?.totalVolume?.includes(searchQuery) || item?.totalOpenInterest?.includes(searchQuery))

  return (
    <LayoutContainer title={`${t('VOLUME_AND_INTEREST_DATA')} - ${selectedValue?.marketName?.toUpperCase()} `} breadCrumbsTitle={'volumeInterestData'} showAddButton={true} handleAddButtonClick={handleClickAddButton}>
      <div className="volume-component-wrapper">
        <div className="header-wrapper">
          <div className="search-container">
            <InputText placeholder={t('SEARCH')} value={searchQuery} onChange={(event) => handleSearch(event)} />
          </div>
          <div className="dropdown-wrapper">
            <Dropdown value={selectedValue} onChange={handleChange} options={marketName} optionLabel="marketName" placeholder="Select a Market" className="drop-down" />
          </div>
        </div>

        <div className="table-wrapper">
          <DataTable value={filteredTableData} paginator={filteredTableData?.length} rows={rowCount} pageLinkSize={paginationButtons}>
            {tableColumns.map((column, index) => (
              <Column key={index} field={column.dataField} header={column.text} className={column.className} body={column.body} />
            ))}
          </DataTable>
        </div>
        <DialogModal {...showDialog} onDismiss={handleDismiss} />
      </div>
    </LayoutContainer>
  )
}

export default Loader(ListVolumnAndIntrestData)
